import React from "react";
import "./howItWorks.css";

const steps = [
  {
    num: "01",
    title: "Discovery & Onboarding",
    desc:
      "You share your project vision, goals, and timeline we study your ecosystem, target audience, and current market position.",
  },
  {
    num: "02",
    title: "Strategy Blueprint",
    desc:
      "We build a data-backed marketing plan narrative direction, influencer mapping, timeline, and content pillars.",
  },
  {
    num: "03",
    title: "Campaign Execution",
    desc:
      "Coordinated campaigns across X (Twitter), Telegram, YouTube, and major channels controlled hype and sustained exposure.",
  },
  {
    num: "04",
    title: "Results & Retargeting",
    desc:
      "Performance reports, analytics, and continuous visibility strategies to maintain investor confidence and growth.",
  },
];

const HowItWorks = () => {
  return (
    <section className="hiw-section" id="how-it-works">
      <div className="hiw-container">
        <div className="hiw-header">
          <div className="hiw-badge">PROCESS</div>
          <h2 className="hiw-heading">How It Works</h2>
          <p className="hiw-subtitle">
            We've simplified growth into a clear, result-driven process designed for crypto founders 
            and investors who value time, visibility, and real traction.
          </p>
        </div>

        <div className="hiw-steps">
          {steps.map((s, i) => (
            <div className="hiw-step" key={i}>
              <div className="step-number">
                <span className="step-num-text">{s.num}</span>
                <div className="step-line"></div>
              </div>
              <div className="step-content">
                <h3 className="step-title">{s.title}</h3>
                <p className="step-desc">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="hiw-note">
          With Charamy, every campaign is more than marketing it's market positioning.
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;